import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ChooseOption.css";
import grayFlag from "../../assets/icons/flag.png";
import blackFlag from "../../assets/icons/flag2.png";

const ChooseOption = ({ onGoToExperience, onGoToSpec, onGoToPortfolio }) => {
  const navigate = useNavigate(); // ✅ 추가
  const [expandedCard, setExpandedCard] = useState(null);
  const [hoveredTag, setHoveredTag] = useState(null);

  // 각 카드별 태그 옵션
  const tagOptions = {
    experience: [
      { id: "project", label: "프로젝트" },
      { id: "contest", label: "공모전" },
      { id: "campus", label: "교내활동" },
      { id: "external", label: "대외활동" },
      { id: "startup", label: "창업" },
      { id: "hackathon", label: "해커톤" },
      { id: "volunteer", label: "봉사" },
      { id: "research", label: "연구" },
      { id: "education", label: "교육" },
      { id: "etc", label: "기타" },
    ],
    spec: [
      { id: "certificate", label: "자격증" },
      { id: "award", label: "수상" },
      { id: "career", label: "경력" },
      { id: "language", label: "외국어" },
      { id: "overseas", label: "해외경험" },
    ],
    portfolio: [
      { id: "resume", label: "이력서" },
      { id: "portfolio", label: "포트폴리오" },
    ],
  };

  // 태그 클릭 시 바로 페이지 이동
  const handleTagClick = (cardType, tagId) => {
    console.log("✨ handleTagClick 호출됨:", cardType, tagId);
    //console.log("Props:", { onGoToExperience, onGoToSpec, onGoToPortfolio });

    if (cardType === "experience" && tagId === "contest") {
      //공모전으로 이동
      navigate("/contest", { state: { selectedTag: tagId } });
    } else if (cardType === "experience" && tagId === "project") {
      //프로젝트로 이동
      navigate("/project", { state: { selectedTag: tagId } });
    } else if (cardType === "experience" && tagId === "campus") {
      //교내활동으로 이동
      navigate("/campus", { state: { selectedTag: tagId } });
    } else if (cardType === "experience" && tagId === "external") {
      //대외활동으로 이동
      navigate("/external", { state: { selectedTag: tagId } });
    } else if (cardType === "spec" && tagId === "career") {
      //경력으로 이동
      navigate("/career", { state: { selectedTag: tagId } });
    } else if (cardType === "spec" && tagId === "certificate") {
      //자격증으로 이동
      navigate("/certificate", { state: { selectedTag: tagId } });
    } else if (cardType === "spec" && tagId === "award") {
      //수상으로 이동
      navigate("/award", { state: { selectedTag: tagId } });
    } else if (cardType === "spec" && tagId === "overseas") {
      //해외경험으로 이동
      navigate("/overseas", { state: { selectedTag: tagId } });
    } else if (cardType === "spec" && tagId === "language") {
      //외국어로 이동
      navigate("/language", { state: { selectedTag: tagId } });
    }
  };

  // ✅ 포트폴리오 카드 클릭 시 - onGoToPortfolio prop 사용 (LeftPanel 유지됨!)
  const handlePortfolioClick = () => {
    console.log("✨ 포트폴리오 카드 클릭 - MainPage 내부에서 페이지 전환");
    if (onGoToPortfolio) {
      onGoToPortfolio([]); // 빈 태그 배열 전달 (또는 필요한 값)
    }
  };

  return (
    <div className="choose-option">
      <div className="choose-header">
        <div className="choose-logo">
          <img src="./images/logomark.png" alt="로고" />
        </div>
        <h1 className="choose-title">무엇을 정리할까요?</h1>
        <p className="choose-subtitle">
          지금까지의 활동을 정리해 기록으로 남겨요
        </p>
      </div>

      <div className="option-container">
        {/* 경험 카드 */}
        <div
          className={`option-card ${
            expandedCard === "experience" ? "expanded experience-card" : ""
          }`}
          onMouseEnter={() => setExpandedCard("experience")}
          onMouseLeave={() => setExpandedCard(null)}
        >
          {expandedCard === "experience" ? (
            <div className="card-expanded-content">
              <div className="tag-container experience-tags">
                {tagOptions.experience.map((tag) => (
                  <button
                    key={tag.id}
                    className={`tag-chip ${
                      hoveredTag === `experience-${tag.id}` ? "hovered" : ""
                    }`}
                    onClick={() => handleTagClick("experience", tag.id)}
                    onMouseEnter={() => setHoveredTag(`experience-${tag.id}`)}
                    onMouseLeave={() => setHoveredTag(null)}
                  >
                    <img
                      src={
                        hoveredTag === `experience-${tag.id}`
                          ? blackFlag
                          : grayFlag
                      }
                      alt="flag"
                      className="tag-icon"
                    />
                    <span className="tag-label">{tag.label}</span>
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <img
              src="./images/Card_Experience.png"
              alt="경험 - 프로젝트, 동아리, 공모전 등 나의 경험을 기록해요"
            />
          )}
        </div>

        {/* 스펙 카드 */}
        <div
          className={`option-card ${
            expandedCard === "spec" ? "expanded spec-card" : ""
          }`}
          onMouseEnter={() => setExpandedCard("spec")}
          onMouseLeave={() => setExpandedCard(null)}
        >
          {expandedCard === "spec" ? (
            <div className="card-expanded-content">
              <div className="tag-container spec-tags">
                {tagOptions.spec.map((tag) => (
                  <button
                    key={tag.id}
                    className={`tag-chip ${
                      hoveredTag === `spec-${tag.id}` ? "hovered" : ""
                    }`}
                    onClick={() => handleTagClick("spec", tag.id)}
                    onMouseEnter={() => setHoveredTag(`spec-${tag.id}`)}
                    onMouseLeave={() => setHoveredTag(null)}
                  >
                    <img
                      src={
                        hoveredTag === `spec-${tag.id}` ? blackFlag : grayFlag
                      }
                      alt="flag"
                      className="tag-icon"
                    />
                    <span className="tag-label">{tag.label}</span>
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <img
              src="./images/Card_Spec.png"
              alt="스펙 - 자격증, 수상, 어학 등 나의 역량을 정리해요"
            />
          )}
        </div>

        {/* 포트폴리오 카드 - ✅ 호버 기능 주석처리, 클릭 시 바로 이동 */}
        <div
          className="option-card"
          onClick={handlePortfolioClick}
          style={{ cursor: 'pointer' }}
          // ========== 호버로 태그 선택하는 기능 주석처리 ==========
          // className={`option-card ${
          //   expandedCard === "portfolio" ? "expanded portfolio-card" : ""
          // }`}
          // onMouseEnter={() => setExpandedCard("portfolio")}
          // onMouseLeave={() => setExpandedCard(null)}
          // ======================================================
        >
          {/* ========== 호버 시 태그 선택 UI 주석처리 ========== */}
          {/* {expandedCard === "portfolio" ? (
            <div className="card-expanded-content">
              <div className="tag-container portfolio-tags">
                {tagOptions.portfolio.map((tag) => (
                  <button
                    key={tag.id}
                    className={`tag-chip ${
                      hoveredTag === `portfolio-${tag.id}` ? "hovered" : ""
                    }`}
                    onClick={() => handleTagClick("portfolio", tag.id)}
                    onMouseEnter={() => setHoveredTag(`portfolio-${tag.id}`)}
                    onMouseLeave={() => setHoveredTag(null)}
                  >
                    <img
                      src={
                        hoveredTag === `portfolio-${tag.id}`
                          ? blackFlag
                          : grayFlag
                      }
                      alt="flag"
                      className="tag-icon"
                    />
                    <span className="tag-label">{tag.label}</span>
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <img
              src="./images/Card_Portfolio.png"
              alt="포트폴리오 - 내가 쌓은 경험과 스펙, 스킬을 모아 정리해요"
            />
          )} */}
          {/* ======================================================= */}
          
          {/* ✅ 항상 카드 이미지만 보여주기 */}
          <img
            src="./images/Card_Portfolio.png"
            alt="포트폴리오 - 내가 쌓은 경험과 스펙, 스킬을 모아 정리해요"
          />
        </div>
      </div>
    </div>
  );
};

export default ChooseOption;